<template lang="pug">
  include /mixins
  +b.search-form--widget.relative
    +b.search-trigger.--fixed-width(
    )
      +e.loop.icon-search
    +b.d-control-input.--appearance_flexible
      d-control-input(
        v-model='checked'
        :name='filter.label'
        autocomplete='nddddo'
        label='caption'
        type='search'
        :id='`${filter.label}`'
        :placeholder='filter.title',
        @input='handleSubmit'
        @keyup.enter='submit'
      )
    +e.close.mdi.mdi-close(
      :class="{ 'hasBtn': hasBtn }"
      v-if='checked'
      @click='() => { checked = ""; submit() }'
    )
    +e.btn.BUTTON(v-if='hasBtn' @click='submit') {{ _('Найти') }}
</template>
<script>
import {
  isEmpty,
} from '@aspectus/vue-utils'

export default {
  name: 'SimpleSearch',
  props: {
    value: {
    },
    filter: {
      type: Object,
    },
    available: {
      type: Boolean,
      default: true,
    },
    hasBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: '',
    }
  },
  watch: {
    value(nval) {
      this.checked = this.normalizeFrom(nval)
    },
  },
  mounted() {
    this.checked = this.normalizeFrom(this.value)
  },
  methods: {
    handleSubmit() {
      if (!this.hasBtn) {
        this.submit()
      }
    },
    submit() {
      const length = 2
      const zero = 0
      if (this.checked.length >= length) {
        this.$emit('input', [this.checked])
        return
      }
      if (this.checked.length == zero) {
        this.$emit('input', [])
      }
    },
    normalizeTo(value) {
      if (!value) return ''
      const checked = this.filter.values
        .filter(el => value.props.label == el.props.label)
        .map(el => el.props.label)
      return checked
    },
    normalizeFrom(value) {
      if (isEmpty(value)) return ''
      const checked = value[0]
      return checked
    },
  },
}
</script>
